__turbopack_context__.v({
  "avatar": "AvatarGroup-module-scss-module__q54KJq__avatar",
});
